<template>
  <div class="marketplace-welcome-banner">
    <div class="welcome-content">
      <div class="welcome-icon">
        <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="70" cy="70" r="70" fill="url(#welcomeGradient)"/>

          <rect x="40" y="45" width="60" height="50" rx="4" fill="white" opacity="0.9"/>
          <rect x="45" y="50" width="50" height="3" fill="#5624d0"/>
          <rect x="45" y="58" width="40" height="2" fill="#a435f0"/>
          <rect x="45" y="65" width="35" height="2" fill="#a435f0"/>
          <rect x="45" y="72" width="30" height="2" fill="#a435f0"/>

          <circle cx="95" cy="35" r="18" fill="#ff6b35"/>
          <path d="M90 40l5-8 5 8M95 32v16" stroke="white" stroke-width="2.5" stroke-linecap="round"/>

          <path d="M25 25l2 6 6 0-5 4 2 6-5-4-5 4 2-6-5-4 6 0z" fill="#ffd700" opacity="0.8"/>
          <path d="M115 110l1.5 4.5 4.5 0-3.5 3 1.5 4.5-3.5-3-3.5 3 1.5-4.5-3.5-3 4.5 0z" fill="#ffd700" opacity="0.6"/>

          <defs>
            <linearGradient id="welcomeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#a435f0;stop-opacity:0.9" />
              <stop offset="100%" style="stop-color:#5624d0;stop-opacity:0.9" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div class="welcome-text">
        <h1>{{ $t('welcome_to_marketplace') }}</h1>
        <p class="welcome-description">
          {{ $t('marketplace_welcome_description') }}
        </p>

        <div class="welcome-features">
          <div class="feature-item">
            <span class="feature-text">{{ $t('reach_thousands_of_learners') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('earn_from_your_expertise') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('build_your_reputation') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('grow_your_business') }}</span>
          </div>
        </div>

        <div class="welcome-actions">
          <button class="primary-button" @click="$router.push('/marketplace/create')">
            {{ $t('share_your_first_course') }}
          </button>
        </div>

        <div class="welcome-stats">
          <div class="stat-item">
            <p>{{ $t('courses_available') }}</p>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <p>{{ $t('potential_students') }}</p>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <p>{{ $t('be_the_first') }}</p>
          </div>
        </div>

        <div class="welcome-steps">
          <h3>{{ $t('getting_started_is_easy') }}:</h3>
          <div class="steps-list">
            <div class="step-item">
              <span class="step-number">1</span>
              <span class="step-text">{{ $t('create_your_course_content') }}</span>
            </div>
            <div class="step-item">
              <span class="step-number">2</span>
              <span class="step-text">{{ $t('set_your_price_and_details') }}</span>
            </div>
            <div class="step-item">
              <span class="step-number">3</span>
              <span class="step-text">{{ $t('publish_and_start_earning') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketplaceWelcomeBanner',
  emits: ['share-course', 'learn-more']
}
</script>

<style scoped>
.marketplace-welcome-banner {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f0f2ff 100%);
  border: 3px dashed #e1e5e9;
  border-radius: 16px;
  margin: 40px 0;
  padding: 60px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.marketplace-welcome-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(164, 53, 240, 0.05) 0%, transparent 70%);
  animation: pulse 4s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.1); opacity: 0.1; }
}

.welcome-content {
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.welcome-icon {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.welcome-text h1 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 36px;
  color: #1c1d1f;
  margin: 0 0 16px 0;
  line-height: 1.2;
  background: linear-gradient(135deg, #5624d0, #a435f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-description {
  font-size: 18px;
  color: #6a6f73;
  margin: 0 0 40px 0;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.welcome-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin: 40px 0;
  padding: 32px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  background: #f8f9fa;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(86, 36, 208, 0.15);
}

.feature-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.feature-text {
  font-size: 14px;
  color: #1c1d1f;
  font-weight: 600;
  text-align: left;
}

.welcome-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 40px 0;
  flex-wrap: wrap;
}

.btn-icon {
  font-size: 20px;
}

.welcome-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin: 50px 0;
  padding: 24px;
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  border-radius: 12px;
  border: 1px solid #e1e5e9;
}

.stat-item {
  text-align: center;
}

.stat-item h3 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 32px;
  color: #5624d0;
  margin: 0 0 4px 0;
}

.stat-item p {
  font-size: 12px;
  color: #6a6f73;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: #e1e5e9;
}

.welcome-steps {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 12px;
  padding: 32px;
  margin: 40px 0 0 0;
  text-align: left;
}

.welcome-steps h3 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 18px;
  color: #856404;
  margin: 0 0 20px 0;
  text-align: center;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.step-number {
  background: #5624d0;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.step-text {
  font-size: 15px;
  color: #856404;
  font-weight: 600;
}

@media (max-width: 768px) {
  .marketplace-welcome-banner {
    padding: 40px 20px;
    margin: 20px 0;
  }

  .welcome-text h1 {
    font-size: 28px;
  }

  .welcome-description {
    font-size: 16px;
  }

  .welcome-features {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 20px;
  }

  .feature-item {
    padding: 12px;
  }

  .welcome-actions {
    flex-direction: column;
    align-items: center;
  }

  .learn-more-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .welcome-stats {
    gap: 20px;
    padding: 16px;
  }

  .stat-item h3 {
    font-size: 24px;
  }

  .welcome-steps {
    padding: 20px;
  }

  .steps-list {
    gap: 12px;
  }

  .step-item {
    gap: 12px;
  }
}
</style>
